export const environment = {
  production: true,
  // apiBaseUrl: 'https://uatsecureservices.fadavis.com/ShoppingCart/api',
  ShoppingCartUrl: 'https://shoppingcart.fadavis.com',
  apiBaseUrl: 'https://services.fadavis.com/ShoppingCart/api',
  apiFadavisWebApiUrl: `https://services.fadavis.com/FADavisWebAPI/api`,
  apiNodeUrl:`https://fadavisapi.fadavis.com/api/v1`,
  imageUrl: 'https://www.fadavis.com/images/thumbnail',
  contactUsUrl: 'https://customersupport.fadavis.com/home/',
  SSOAccount: 'https://services.fadavis.com/UniversalProfile/Account/GetMyProfile',
  SSOProducts: 'https://www.fadavis.com/MyProducts',
  SSOHelp: 'https://customersupport.fadavis.com/home/',
  AppName: 'ShoppingCart',
  env: 'prod',
  CookieName: 'prodFADSSO',
  logoImagePath: '../../../assets/logo.png',
  fadavisUrlSufix: '/index.aspx',
  defaultProductImage: 'https://www.fadavis.com/images/thumbnail/GEN.jpg',

  FADBaseUrl: 'https://www.fadavis.com/',

  MLLHomeUrl: 'https://medicallanguagelab.fadavis.com/Home/Main',
  DEHomeurl: 'https://davisedge.fadavis.com/Home/Index/',
  DPHomeurl: 'https://davisplus.fadavis.com/',
  MCLHomeurl: 'https://medicalcodinglab.fadavis.com/Home/Main',
  FitnessHomeurl: 'https://fitnessdecisions.fadavis.com/Home/Main',
  KIAHomeurl: 'https://kinesinaction.fadavis.com/Home/Main',
  CDOHomeurl: 'https://dosagecalc.fadavis.com/',
  AdvantageHomeurl: 'https://www.davisadvantage.com/',
  DentalHomeurl: 'https://dentalcaredecisions.fadavis.com/',
  OrderSearchurl: 'https://www.fadavis.com/OrderSearch',
  DC360Url: 'http://dosagecalc360.fadavis.com',
  FADHomeUrl: `https://www.fadavis.com/`,
  sessionTimeout: 7200,
  SessionTimeoutPopUp: 7140,
  UspsUrl: 'https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=',
  USPSAPIURL: 'https://secure.shippingapis.com/ShippingAPI.dll',
  USPSUserID: '571FADAV0161',
  USPSPassword: '276UP28OS582',
  footerXmlPath: `https://www.fadavis.com/`,
  davisadvantageLoginUrl: `https://platform.davisadvantage.com/accounts/authenticate`,
  MarketoLeadFormUrl: `//go.fadavis.com`,
  MarketoLeadMunchkinId: `312-SPT-784`,
  MarketoLeadFormId: 2715,
  appConfig: {
    '1': {
      'appName': 'Medical Language Lab',
      'logoImagePath': '../../../assets/logo/medlab-logo.png', 'color': '#6b6d6e', 'checkcolor': '#bd202d',
      'UrlSufix': '/Product/ProductList'
    },
    '2': {
      'appName': 'DavisPlus',
      'logoImagePath': '../../../assets/logo/davisplus-logo.png', 'color': '#1b75bc', 'checkcolor': '#f58220',
      'UrlSufix': ''
    },
    '3': {
      'appName': 'Calculating Dosages Online',
      'logoImagePath': '../../../assets/logo/cdo-logo.png', 'color': '#B4CB3D', 'checkcolor': '#B4CB3D',
      'UrlSufix': '/Product/ProductDashboard'
    },
    '4': {
      'appName': 'Davis Edge',
      'logoImagePath': '../../../assets/logo/davisedge-logo.png', 'color': '#125d91', 'checkcolor': '#125d91',
      'UrlSufix': '/Product/ProductList'
    },
    '5': {
      'appName': 'FADavis.com',
      'logoImagePath': '../../../assets/logo/fadavis-logo.png', 'color': '#277F5C', 'checkcolor': '#3c763d',
      'UrlSufix': '/'
    },
    '6': {
      'appName': 'DavisPlus IPad App',
      'logoImagePath': '../../../assets/logo/davisplus-logo.png', 'color': '#175e8f', 'checkcolor': '#f58220',
      'UrlSufix': '/Home/Index'
    },
    '7': {
      'appName': 'Kinesiology In Action',
      'logoImagePath': '../../../assets/logo/kia-logo.png', 'color': '#2a3990', 'checkcolor': '#8cc63f',
      'UrlSufix': '/Product/ProductDashboard'
    },
    '8': {
      'appName': 'Dental Care Decisions',
      'logoImagePath': '../../../assets/logo/dental-logo.png', 'color': '#1b75bc', 'checkcolor': '#39b54a ',
      'UrlSufix': '/Product/ProductDashboard'
    },
    '9': {
      'appName': 'Fitness Decisions',
      'logoImagePath': '../../../assets/logo/fitness-logo.png', 'color': '#414142', 'checkcolor': '#8cc63f',
      'UrlSufix': '/Product/ProductDashboard'
    },
    '10': {
      'appName': 'Medical Coding Lab',
      'logoImagePath': '../../../assets/logo/medical-logo.png', 'color': '#00adef', 'checkcolor': '#f1622c',
      'UrlSufix': '/Product/ProductList'
    },
    '11': {
      'appName': 'Davis Advantage',
      'logoImagePath': '../../../assets/logo/davisadvantage-logo.png', 'color': '#6658A6', 'checkcolor': '#3366cc',
      'UrlSufix': '/'
    },
    '13': {
      'appName': 'Dosage Calc 360',
      'logoImagePath': '../../../assets/logo/dosage-logo.png', 'color': '#036cad', 'checkcolor': '#90c150',
      'UrlSufix': '/Product/ProductDashboard'
    },
    '14': {
      'appName': 'Surg Tech in Practice',
      'logoImagePath': '../../../assets/logo/surgtech-logo.jpg', 'color': '#1f82c0', 'checkcolor': '#0d3183',
      'UrlSufix': '/'
    }
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts